
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_MarketingLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_MarketingLayout__root","text-medium-bold":"wds_1_182_0_StylableTypography__text-medium-bold","contentContainer":"wds_1_182_0_MarketingLayout__contentContainer","contentWrapper":"wds_1_182_0_MarketingLayout__contentWrapper","title":"wds_1_182_0_MarketingLayout__title","description":"wds_1_182_0_MarketingLayout__description","badge":"wds_1_182_0_MarketingLayout__badge","imageWrapper":"wds_1_182_0_MarketingLayout__imageWrapper","imagePlaceholder":"wds_1_182_0_MarketingLayout__imagePlaceholder","imageBackground":"wds_1_182_0_MarketingLayout__imageBackground"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"badgePaddingSize":"--wds_1_182_0_MarketingLayout-badgePaddingSize"}; 




